import React, { Fragment } from 'react';
import { Card } from 'reactstrap';

const ProductIngredientsCard = ({ className, ingredients }) => {
  return (
    <Fragment>
      <h3 className="f3 mt0">Ingredients</h3>
      <Card className={className}>
        <table className="table mb0">
          <thead>
            <tr>
              <th className="bt-n bb-n table-header" />
              <th className="bt-n bb-n table-header">Name</th>
              <th className="bt-n bb-n table-header">Amount</th>
            </tr>
          </thead>
          <tbody>
            {ingredients.map(i => (
              <tr className="table-row" key={i.id}>
                <td />
                <td>
                  <strong>{i.name || i.ingredient.name}</strong>
                </td>
                <td>
                  {i.amount} {i.measurementType.toLowerCase()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </Fragment>
  );
};

export default ProductIngredientsCard;



// WEBPACK FOOTER //
// ./src/components/productIngredientsCard/productIngredientsCard.jsx